import * as yup from 'yup'

const validationSchema = yup.object().shape({
  landlinePhone: yup
    .string()
    .optional()
    .transform((value) => value.replace(/\D/g, '')) // remove máscara
    .matches(
      /^\d{2}\d{10}$/,
      'Telefone fixo deve estar no formato correto com DDI + DDD + número'
    ),
  phone: yup
    .string()
    .required('O telefone é obrigatório')
    .transform((value) => value.replace(/\D/g, '')) // remove máscara
    .matches(
      /^\d{4}9\d{8}$/,
      'O telefone deve estar no formato correto com DDI + DDD + número iniciando com 9'
    ),
  email: yup.string().email().required()
})

export default validationSchema
